<template>
  <div class="text-white font-bold text-3xl text-center">ІНТЕЛШКОЛА</div>
</template>
